import { render, staticRenderFns } from "./feedback-comment-form.vue?vue&type=template&id=0842293f&scoped=true&"
import script from "./feedback-comment-form.vue?vue&type=script&lang=js&"
export * from "./feedback-comment-form.vue?vue&type=script&lang=js&"
import style0 from "./feedback-comment-form.vue?vue&type=style&index=0&id=0842293f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0842293f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VTextarea,VTooltip})
